// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import { ColorProps, color } from '../../styled/color';
import { TextAlignProps, textAlign } from '../../styled/text';

interface TextProps {
  weight?: 'Light' | 'Regular' | 'Medium' | 'Bold';
}

export default styled.p<TextProps & ColorProps & TextAlignProps>`
  font-weight: ${({ weight }) => weight === 'Light' ? 300 : weight === 'Regular' ? 400 : weight === 'Bold' ? 700 : 500 };
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.29px;
  ${color}
  ${textAlign}
`;
